var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertismentIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24Z",
    fill: "url(#paint0_linear_4003_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.49185C15.2724 4.49185 17.4095 5.37685 19.0163 6.9837C20.6232 8.59055 21.5082 10.727 21.5082 13C21.5082 15.273 20.6232 17.4095 19.0163 19.0163C17.4095 20.6232 15.273 21.5082 13 21.5082C10.727 21.5082 8.59055 20.6232 6.9837 19.0163C5.37685 17.4095 4.49185 15.273 4.49185 13C4.49185 10.727 5.37685 8.59055 6.9837 6.9837C8.59055 5.37685 10.727 4.49185 13 4.49185ZM13 2C6.92478 2 2 6.92478 2 13C2 19.0752 6.92478 24 13 24C19.0752 24 24 19.0752 24 13C24 6.92478 19.0752 2 13 2Z",
    fill: "url(#paint1_linear_4003_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 9.52215C14.9156 9.52215 16.4752 11.0817 16.4752 12.9987C16.4752 14.9157 14.9156 16.4752 12.9987 16.4752C11.0817 16.4752 9.52212 14.9157 9.52212 12.9987C9.52212 11.0817 11.0817 9.52215 12.9987 9.52215ZM12.9987 7.0303C9.7021 7.0303 7.03027 9.70278 7.03027 12.9987C7.03027 16.2946 9.70275 18.9671 12.9987 18.9671C16.2946 18.9671 18.9671 16.2946 18.9671 12.9987C18.9671 9.70278 16.2946 7.0303 12.9987 7.0303Z",
    fill: "url(#paint2_linear_4003_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5287 4.51905C23.1371 4.43035 22.7182 4.34749 22.2818 4.26656C22.0041 4.21477 21.7833 3.994 21.7315 3.71627C21.6506 3.28057 21.5678 2.86105 21.4791 2.46937C21.3735 1.98447 20.6096 1.8524 20.1894 2.18258C19.2908 2.91349 18.1508 4.01019 17.3758 4.86476C17.2263 5.0292 17.1654 5.27715 17.2062 5.52252C17.3098 6.13885 17.4011 6.75711 17.4885 7.35467L12.4213 12.4219C12.1027 12.7404 12.1027 13.2577 12.4213 13.5762C12.5805 13.7355 12.7896 13.8151 12.9987 13.8151C13.2079 13.8151 13.4163 13.7355 13.5762 13.5762L18.6434 8.50898C19.2403 8.59638 19.8593 8.68767 20.4756 8.79125C20.721 8.83204 20.9689 8.77118 21.1333 8.62163C21.9879 7.84669 23.0846 6.70662 23.8155 5.80802C24.1457 5.38786 24.0136 4.62393 23.5287 4.5184V4.51905Z",
    fill: "url(#paint3_linear_4003_152)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_152",
    x1: 20.7785,
    y1: 20.7785,
    x2: 5.22212,
    y2: 5.22212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_152",
    x1: 20.7785,
    y1: 20.7785,
    x2: 5.22212,
    y2: 5.22212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#506EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4003_152",
    x1: 17.2191,
    y1: 17.2191,
    x2: 8.77826,
    y2: 8.77829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#506EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4003_152",
    x1: 19.3892,
    y1: 10.4046,
    x2: 15.5935,
    y2: 6.60886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#506EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertismentIconActive);
export default __webpack_public_path__ + "static/media/advertismentIconActive.288e84d63d34e3a2a288d681e5fedaf9.svg";
export { ForwardRef as ReactComponent };